export default __webpack_public_path__ + "static/media/山海世界.2260ec14.jpg";